import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference types="../../theme.d.ts" />
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { AppBar as MuiAppBar, Toolbar, Grid, Stack, Paper, Typography, InputBase, IconButton, Divider, } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
// import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
// import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useStore, useTokens } from '@mcn-platform/models';
import CustomButton from '../../portal/common/CustomButton';
import AssetImage from '../../portal/common/asset/AssetImage';
import linkNavigator from '../../portal/common/linkNavigator';
import AccountButton from '../../portal/nav/AccountButton';
import MobileCategoryNav from '../../portal/nav/MobileCategoryNav';
const StyledDivider = () => (_jsx(Divider, { orientation: "vertical", sx: {
        height: '34px !important',
        borderColor: 'palette.divider',
        marginTop: 'auto !important',
        marginBottom: 'auto !important',
    } }));
const HubAppBar = ({ rootCategory, title, showLogo, showSearch, showMyLeanringsBtn: showMyLearnings, showMyMeetings, showProfileBtn, limitToPageWidth, searchAction, sticky, editData, showSubCategoryDropdowns, showCustomBtn, link, label, }) => {
    const tokens = useTokens();
    // console.log('rootCategoryAppbar:', rootCategory);
    const [searchParams] = useSearchParams();
    const [isMobileView, setIsMobileView] = useState(false);
    const [searchText, setSearchText] = React.useState(searchParams.get('q') || '');
    const flexEnd = {
        display: 'flex',
        direction: 'row',
        justifyContent: 'flex-end',
    };
    const store = useStore();
    const portal = store.currentPortal;
    const hub = store.currentHub;
    const searchHandler = (e) => {
        e.preventDefault();
        if (!searchAction) {
            console.log('No search action wired for the component');
            return false;
        }
        searchAction(searchText);
        return false;
    };
    const handleResize = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 600 && !isMobileView) {
            setIsMobileView(true);
        }
        else if (windowWidth > 600 && !isMobileView) {
            setIsMobileView(false);
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize, false);
        handleResize();
    });
    const navigate = useNavigate();
    const handleClick = (ev) => {
        linkNavigator(link, editData ? (l) => editData.preNavigationHook(l, ev) : navigate);
    };
    return (_jsx(MuiAppBar, { position: sticky ? 'sticky' : 'static', elevation: 0, sx: {
            minHeight: 48,
            py: 1,
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
            }),
            // backgroundColor: (t) => (t.portal.site.background.color),
        }, children: _jsx(Toolbar, { children: _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 12, md: 3, lg: 3, children: _jsxs(Stack, { spacing: 2, direction: "row", 
                            // divider={!isMobileView ? <StyledDivider /> : ''}
                            sx: {
                                height: '100%',
                                alignItems: 'center',
                                justifyContent: { xs: 'center', lg: 'flex-start' },
                                marginRight: '20px',
                            }, children: [isMobileView && (_jsx(MobileCategoryNav, { rootCategory: rootCategory, showSubCategoryDropdowns: showSubCategoryDropdowns })), showLogo && hub?.logoImage && (_jsx(Link, { to: "home", onClick: (ev) => editData && editData.preNavigationHook('home', ev), children: _jsx(AssetImage, { asset: hub.logoImage, customStyle: {
                                            width: '100%',
                                        }, size: "thumb400w" }) })), _jsx(Typography, { component: "div", variant: "h4", fontWeight: "fontWeightMedium", sx: { alignItems: 'center' }, children: title })] }) }), _jsxs(Grid, { container: true, item: true, xs: 12, md: 9, lg: 9, children: [_jsx(Grid, { item: true, lg: true, sm: true, container: true, sx: {
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: { xs: 'flex-start', lg: 'flex-end' },
                                }, children: _jsx(Grid, { item: true, sx: {
                                        alignItems: 'center',
                                        m: 1,
                                    }, lg: 12, xs: 12, md: 12, children: showSearch && (_jsxs(Paper, { component: "form", sx: {
                                            display: 'flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            backgroundColor: (theme) => (theme.portal?.site?.searchBar?.backgroundColor),
                                            border: (theme) => `2px solid ${theme.portal?.site?.searchBar?.borderColor}`,
                                            borderRadius: '22px',
                                            height: '34px',
                                        }, elevation: 0, onSubmit: searchHandler, children: [_jsx(InputBase, { value: searchText, sx: {
                                                    px: 2,
                                                    flex: 1,
                                                    typography: 'body2',
                                                    color: (theme) => (theme.portal?.site?.searchBar?.color),
                                                }, placeholder: "What would you like to learn today?", inputProps: { 'aria-label': 'search' }, onChange: (e) => setSearchText(e.target.value) }), _jsx(IconButton, { type: "submit", sx: {
                                                    mr: 0.5,
                                                    color: (theme) => (theme.portal?.site?.searchBar?.color),
                                                }, "aria-label": "search", children: _jsx(SearchIcon, { fontSize: "medium", color: "inherit" }) })] })) }) }), _jsxs(Grid, { item: true, container: true, sx: {
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: { xs: 'center', lg: 'flex-end' },
                                    width: { xs: '100%', sm: 'auto' },
                                    flex: '0 0 auto',
                                }, children: [showCustomBtn && (_jsx(Grid, { alignItems: "center", sx: {
                                            alignItems: 'center',
                                            mx: 1,
                                        }, children: _jsx(CustomButton, { label: label, onClick: handleClick }) })), showMyLearnings && !(portal?.type === 'public' && store.isAnonymous) && (_jsx(Grid, { item: true, alignItems: "center", sx: {
                                            ...flexEnd,
                                            alignItems: 'center',
                                            m: 1,
                                        }, children: _jsx(CustomButton, { label: tokens.getToken('myLearningsLabel'), onClick: () => navigate('./my-learnings') }) })), showMyMeetings && !(portal?.type === 'public' && store.isAnonymous) && (_jsx(Grid, { item: true, alignItems: "center", sx: {
                                            ...flexEnd,
                                            alignItems: 'center',
                                            m: 1,
                                        }, children: _jsx(CustomButton, { label: tokens.getToken('myMeetingsLabel'), onClick: () => navigate('./my-meetings') }) })), _jsx(Grid, { item: true, sx: {
                                            ...flexEnd,
                                            alignItems: 'right',
                                            m: 1,
                                        }, children: _jsx(Stack, { direction: "row", spacing: 1, divider: _jsx(StyledDivider, {}), children: showProfileBtn && (_jsx(AccountButton, {})) }) })] })] })] }) }) }));
};
/** Preload the logo */
HubAppBar.getData = async ({ showLogo, }, store) => {
    // console.log('HubAppBar.getData()', store?.currentPortal?.logoImage);
    // console.log(' showLogo', showLogo);
    if ((showLogo === undefined || showLogo) && store.currentPortal.logoImage) {
        const logoAsset = store.currentPortal.logoImage;
        if (logoAsset) {
            // console.log('loading asset', logoAsset);
            await store.load('asset', logoAsset.key);
            // console.log('loading repo');
            await store.load('repository', logoAsset.repository.key);
            // console.log('signing');
            await logoAsset.getSignedUrl('thumb400w');
        }
    }
    // console.log('HubAppBar.getData() end');
    return 'ok';
};
HubAppBar.defaultProps = {
    showLogo: true,
    showSearch: true,
    showMyLeanringsBtn: true,
    showMyMeetings: false,
    showCustomBtn: false,
    showProfileBtn: true,
    sticky: false,
};
HubAppBar.meta = {
    group: 'hub',
    name: 'Hub App Bar',
    description: 'Top global Bar for the Hub',
    props: [
        {
            key: 'showLogo',
            name: 'Show Logo',
            type: 'boolean',
            description: 'Show the logo on app header',
        },
        {
            key: 'showSearch',
            name: 'Show Search',
            type: 'boolean',
            description: 'Show the search container on app header',
        },
        {
            key: 'searchAction',
            name: 'Search Action',
            type: 'select',
            values: ['@searchAction', '@searchMemberships'],
            label: 'Search Action',
            labels: ['Search Courses and Programs', 'Search Memberships'],
            description: 'Action to take when user performs a search.',
        },
        {
            key: 'showMyLeanringsBtn',
            name: 'Show My Learnings Button',
            type: 'boolean',
            description: 'Show my learnings button on app header',
        },
        {
            key: 'showMyMeetings',
            name: 'Show My Meetings Button',
            type: 'boolean',
            description: 'Show My Meetings button on app header',
        },
        {
            key: 'showCustomBtn',
            name: 'Show Custom Button',
            type: 'boolean',
            description: 'Show custom button on app header',
        },
        {
            key: 'label',
            name: 'Custom Button Label',
            type: 'text',
            description: 'Custom button label.',
        },
        {
            key: 'link',
            name: 'Custom Button Click Action',
            type: 'link',
            description: 'Link to go to when button clicked.',
        },
        {
            key: 'showProfileBtn',
            name: 'Show Profile Button',
            type: 'boolean',
            description: 'Show the loggedIn profile details button on app header.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
        },
        {
            key: 'rootCategory',
            name: 'Root Category',
            type: 'category',
            description: 'Category that holds the top level categories beneath it.',
        },
        {
            key: 'showSubCategoryDropdowns',
            name: 'Show SubCategory Dropdowns',
            type: 'boolean',
            description: 'Instead of linking to the category, show the menu of SubCategories.',
        },
        {
            key: 'sticky',
            name: 'Sticky To Top',
            type: 'boolean',
            description: 'Keep bar at the top of the page when scrolling',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'HubAppBar',
        props: {
            showLogo: true,
            label: 'Button',
            link: {
                type: 'none',
            },
            showSearch: true,
            showMyLeanringsBtn: true,
            showCustomBtn: false,
            showProfileBtn: true,
            sticky: false,
            limitToPageWidth: true,
            searchAction: '@searchAction',
            rootCategory: '@rootCategory',
        },
    },
};
export default observer(HubAppBar);
//# sourceMappingURL=HubAppBar.js.map